import { formatTime } from '@seen/core/dates'
import { referenceDisplay } from '@seen/core/display'
import type { ExtendedAppointment } from '@seen/core/models/appointments/appointment'
import { DotSeparator, TypographySubtle } from '@seen/ui'
import { format } from 'date-fns'
import { Fragment, type JSX } from 'react'
import { HoverPractitioner } from '#src/components/core/hover-card/HoverPractitioner.tsx'

export function AppointmentDisplay({
  appointment,
  onClick,
}: {
  appointment: ExtendedAppointment
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
}): JSX.Element {
  const [healthcareService] = appointment.healthcareServices
  return (
    <TypographySubtle
      className="inline-flex items-center gap-1"
      onClick={onClick}
      // onMouseDown stops the event from propagating to parent elements
      // This prevents the parent's click handlers from firing when clicking this element
      onMouseDown={(e) => e.stopPropagation()}
    >
      <span>
        {appointment.start ? format(appointment.start, 'h:mm') : '?'}-
        {appointment.end ? formatTime(appointment.end) : '?'}
      </span>
      {referenceDisplay(healthcareService) && (
        <>
          <DotSeparator />
          <span className="text-foreground-secondary">
            {referenceDisplay(healthcareService)}
          </span>
        </>
      )}
      {appointment.practitioners.length > 0 && (
        <span className="inline-flex gap-1 text-foreground-secondary">
          <DotSeparator />
          {appointment.practitioners.map((practitioner, idx) => (
            <Fragment key={practitioner.reference}>
              {idx > 0 && <span>&</span>}
              <HoverPractitioner practitioner={practitioner} />
            </Fragment>
          ))}
        </span>
      )}
    </TypographySubtle>
  )
}
